/**
 * @generated SignedSource<<1d3aa3e5c00f27b82fc1aa3a6b3b2b36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DaySheetlyPageDeleteMutation$variables = {
  id: string;
};
export type DaySheetlyPageDeleteMutation$data = {
  readonly deleteTask: string;
};
export type DaySheetlyPageDeleteMutation = {
  response: DaySheetlyPageDeleteMutation$data;
  variables: DaySheetlyPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteTask",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DaySheetlyPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DaySheetlyPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c287bfbea047d7629f618a30dcb5db4",
    "id": null,
    "metadata": {},
    "name": "DaySheetlyPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation DaySheetlyPageDeleteMutation(\n  $id: ID!\n) {\n  deleteTask(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b7d1fc04c7c263a53fd478917e02ca3d";

export default node;
